import { showDialog, isCancellationError } from '@components/Dialog'

export const fireDialog = callback => {
  return showDialog({
    title: 'Are you sure?',
    text: 'Continuing will mean the extract will lose all the manual changes',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes'
  })
    .then(callback)
    .catch(err => isCancellationError(err))
}

export const checkPlaceholderErrors = content => {
  const positionOptions = [
    '{{{relevantPositionOnly}}}',
    '{{{currentPositionOnly}}}',
    '{{{relevantPositionAndCurrentPosition}}}',
    '{{{allPositionsExceptHidden}}}',
    '{{{allPositions}}}'
  ]
  const positionOptionOccurence = positionOptions.filter(opt =>
    content.includes(opt)
  )
  if (positionOptionOccurence.length > 1) {
    return showDialog({
      title: 'Only one of the following position options is possible:',
      html: `<div>${positionOptions
        .map((pos, i) => `<div>${i + 1}. ${pos}</div>`)
        .join('')}</div>`,
      type: 'error'
    }).catch(err => isCancellationError(err))
  }

  const expertNameOptions = [
    '{{expert.fullName}}',
    '{{{expert.hyperlinkedFullName}}}'
  ]
  const expertNameOptionOccurence = expertNameOptions.filter(opt =>
    content.includes(opt)
  )
  if (expertNameOptionOccurence.length > 1) {
    return showDialog({
      title: 'Only one of the following expert name formats is possible:',
      html:
        '<div><div>{{expert.fullName}}</div><div>{{{expert.hyperlinkedFullName}}}</div></div>',
      type: 'error'
    }).catch(err => isCancellationError(err))
  }
}
